export const SET_LOGIN_ID = 'SET_LOGIN_ID';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_INITIAL_LOGIN_STATE = 'SET_INITIAL_LOGIN_STATE';
export const CHANGE_LOGIN_ID = 'CHANGE_LOGIN_ID';
export const CHANGE_PIN = 'CHANGE_PIN';
export const SET_SOCIAL_LOGIN_USER_DETAIL = 'SET_SOCIAL_LOGIN_USER_DETAIL';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_RESET_PATH = 'SET_RESET_PATH';
export const RESET_STATE = 'RESET_STATE';
export const CHANGE_OTP = 'CHANGE_OTP';
export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const LOGIN_USER = {
	SUCCESS: 'LOGIN_USER_SUCCESS',
	FAILURE: 'LOGIN_USER_FAILURE',
	PENDING: 'LOGIN_USER_PENDING',
};
export const SOCIAL_LOGIN = {
	SUCCESS: 'LOGIN_GOOGLE_SUCCESS',
	FAILURE: 'LOGIN_GOOGLE_FAILURE',
	PENDING: 'LOGIN_GOOGLE_PENDING',
};
export const USER_DETAILS = {
	SUCCESS: 'USER_DETAILS_SUCCESS',
	FAILURE: 'USER_DETAILS_FAILURE',
	PENDING: 'USER_DETAILS_PENDING',
};
export const FORGOT_PIN = {
	SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
	FAILURE: 'FORGOT_PASSWORD_FAILED',
	PENDING: 'FORGOT_PASSWORD_PENDING',
};
export const JUNIOR_LOGIN = {
	SUCCESS: 'JUNIOR_LOGIN_SUCCESS',
	FAILURE: 'JUNIOR_LOGIN_FAILED',
	PENDING: 'JUNIOR_LOGIN_PENDING',
};

export const OTP_LOGIN = {
	SUCCESS: 'OTP_LOGIN_SUCCESS',
	FAILURE: 'OTP_LOGIN_FAILED',
	PENDING: 'OTP_LOGIN_PENDING',
};
export const OTP_VERIFY = {
	SUCCESS: 'OTP_VERIFY_SUCCESS',
	FAILURE: 'OTP_VERIFY_FAILED',
	PENDING: 'OTP_VERIFY_PENDING',
};
export const UPDATE_ACTIVE_COURSE = 'UPDATE_ACTIVE_COURSE';
export const UPDATE_FULL_NAME = 'UPDATE_FULL_NAME';
